/**
 * BgmSection -- 배경음악 설정
 */

import { useInvitationStore } from '../../../stores/invitationStore.js'
import { Input, Toggle, Select } from '../../ui/index.js'
import styles from './SectionForm.module.css'

const VOLUME_OPTIONS = [
  { value: '0.25', label: '25%' },
  { value: '0.5', label: '50%' },
  { value: '0.75', label: '75%' },
  { value: '1', label: '100%' },
]

export function BgmSection() {
  const invitation = useInvitationStore((s) => s.invitation)
  const updateNested = useInvitationStore((s) => s.updateNested)
  if (!invitation) return null

  const bgm = (invitation as any).bgm ?? {}

  return (
    <div className={styles.form}>
      <Input
        label="BGM URL"
        value={bgm.url ?? ''}
        onChange={(e) => updateNested('bgm.url', e.target.value)}
        placeholder="https://example.com/bgm.mp3"
      />
      <Input
        label="곡 제목"
        value={bgm.title ?? ''}
        onChange={(e) => updateNested('bgm.title', e.target.value)}
        placeholder="웨딩 마치"
      />
      <Toggle
        label="자동 재생"
        checked={bgm.autoplay !== false}
        onChange={(v) => updateNested('bgm.autoplay', v)}
      />
      <Toggle
        label="반복 재생"
        checked={bgm.loop !== false}
        onChange={(v) => updateNested('bgm.loop', v)}
      />
      <Select
        label="볼륨"
        value={String(bgm.volume ?? 0.5)}
        onChange={(e) => updateNested('bgm.volume', parseFloat(e.target.value))}
        options={VOLUME_OPTIONS}
      />
    </div>
  )
}
